export default __webpack_public_path__ + "static/media/SWT0520.34I-20392_-14785_0.3d3632b5.jpg";